import { useId, type HTMLAttributes, type ReactNode } from 'react';
import { cn } from '../../../lib/utils/cn';

export interface AiGradientIconProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
}

export const AiGradientIcon = ({ children, className, style, ...props }: AiGradientIconProps) => {
  const id = useId();
  const gradId = `aigic${id.replace(/[^a-zA-Z0-9]/g, '')}`;

  return (
    <div
      className={cn('ai-gradient-icon', className)}
      style={{ '--icon-fill': `url(#${gradId})`, ...style } as React.CSSProperties}
      {...props}>
      <svg aria-hidden className="pointer-events-none absolute size-0 overflow-hidden">
        <defs>
          <linearGradient id={gradId} x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="var(--color-electric-violet)" />
            <stop offset="100%" stopColor="var(--color-indigo-crush)" />
          </linearGradient>
        </defs>
      </svg>
      {children}
    </div>
  );
};
